export default "__VITE_ASSET__Clrh4sCG__"